import { CategoriesResponse } from "@app/services/category/types";
import { IDataBiowel } from "@app/store/types";
import { saveRedirectDataToCookies, saveUserDataToCookiesRedirect } from "./userDataToCookies";

interface Category {
  title?: string;
  name?: string;
  url?: string;
}

interface GetExternalUrlParams {
  category?: Category;
  myPayroll?: boolean;
  mySetting?: boolean;
  dataBiowel: IDataBiowel;
  allCategory: CategoriesResponse;
}

export const getExternalUrl = ({
  category,
  dataBiowel,
  allCategory
}: GetExternalUrlParams): string => {
  // Guard: si no hay categoría o no tiene URL, no guardar cookies corruptas
  if (!category?.url) {
    return "";
  }

  const currentCategory = allCategory.all_Categories?.find(
    (cat) => cat?.name === (category?.title || category?.name)
  );

  const { token, idUser, idAccount, userImage, idProfile, fullNameUser } = dataBiowel;

  const userData = {
    token,
    userImage,
    fullNameUser,
    idUser: idUser.toString(),
    idProfile: idProfile.toString(),
    idAccount: idAccount.toString()
  };

  const moduleData = {
    nameModule: category?.title || category?.name || "",
    idModule: currentCategory?.id.toString() || ""
  };

  saveUserDataToCookiesRedirect(moduleData);
  saveRedirectDataToCookies(userData, moduleData);

  return `${category.url}validate`;
};
